import { render, staticRenderFns } from "./NotebookSidebar.vue?vue&type=template&id=49c31656&scoped=true"
import script from "./NotebookSidebar.vue?vue&type=script&lang=ts"
export * from "./NotebookSidebar.vue?vue&type=script&lang=ts"
import style0 from "./NotebookSidebar.vue?vue&type=style&index=0&id=49c31656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c31656",
  null
  
)

export default component.exports